import React from 'react'
import '../../commonCSS/sourceCode.scss'
import CopySource from '../../utils/copySource'

function SourceCodeSnippet({ source }: { source: string }) {
    return (
        <div className="readmeSection">
            <h2 data-testid="description">
                Please use module block below in your configurations to use this
                module:
            </h2>
            <pre className="sourceCode" data-testid="code">
                {source}
                <button
                    className="copyButton"
                    onClick={() => CopySource(source)}
                >
                    <img src='/icons/copy.png' alt="copy" />
                </button>
            </pre>
        </div>
    )
}

export default SourceCodeSnippet
